import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { apiRequest, SUCCESS_URL, FAIL_URL } from '../../../utils/api';

@translate()
class Payment extends Component {
  state = {
    loading: false,
  };

  pay = async (e) => {
    e.preventDefault();
    if (this.state.loading) {
      return;
    }

    const { orderId } = this.props.bill;
    this.setState({ loading: true });

    try {
      const response = await apiRequest({
        url: '/api/Orders/Link',
        method: 'POST',
        body: JSON.stringify({
          orderId,
          successUrl: SUCCESS_URL,
          failUrl: FAIL_URL,
        }),
      });

      if (response && response.success && response.link) {
        window.location.href = response.link;
        return;
      }

      window.alert((response && (response.message || response.error)) || this.props.t('common:payment_error'));
    } catch (error) {
      const message = error && (error.message || error.error);
      window.alert(typeof message === 'string' ? message : this.props.t('common:payment_error'));
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { t, bill: { orderId, amount, paymentDescription, displayDescription } } = this.props;
    const { loading } = this.state;

    return (
      <form
        ref="payment"
        name="PayForm"
        onSubmit={this.pay}
      >
        <input className="payRow" type="hidden" name="order" value={orderId} />
        <input className="payRow" type="text" placeholder={t('common:order_amount')} name="amount" value={amount} readOnly />
        <input
          className="payRow"
          type="text"
          placeholder={t('common:order_description')}
          name="description"
          value={paymentDescription || displayDescription}
          readOnly
        />
        <input
          className="invoice__btn-pay btn"
          type="submit"
          value={t('common:pay')}
          disabled={loading}
        />
      </form>
    );
  }
}

Payment.propTypes = {
  bill: PropTypes.shape({
    displayDescription: PropTypes.string,
    paymentDescription: PropTypes.string,
    amount: PropTypes.number,
    orderId: PropTypes.number,
  }).isRequired,
};
Payment.defaultProps = {};

export default Payment;



// WEBPACK FOOTER //
// ./src/components/Modal/Payment/Payment.js